
import { RetryConfig } from "../types/index";

export const DEFAULT_RETRY_CONFIG: RetryConfig = {
    maxRetries: 3,
    baseDelay: 1000, 
    maxDelay: 10000,
    backoffMultiplier: 2
  };
  
export const RETRY_CONFIGS = {
    DEFAULT: DEFAULT_RETRY_CONFIG,
    UPLOAD: {
      ...DEFAULT_RETRY_CONFIG,
      maxRetries: 2, 
      baseDelay: 2000,
    },
    CONVERSION: {
      ...DEFAULT_RETRY_CONFIG,
      maxRetries: 5,
      baseDelay: 3000, 
      maxDelay: 30000,
    }
  } as const;